// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"405":"c618ae05","585":"586f16c8"}[chunkId] + ".chunk.js";
};